import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useAuth } from "../../contexts/AuthContext";

export default function AppShell() {
    const { user, loading } = useAuth();
    const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
        try {
            return window.localStorage.getItem("fiscox.sidebar.collapsed") === "1";
        } catch {
            return false;
        }
    });

    useEffect(() => {
        try {
            window.localStorage.setItem("fiscox.sidebar.collapsed", sidebarCollapsed ? "1" : "0");
        } catch {
            // The layout still works when browser storage is unavailable.
        }
    }, [sidebarCollapsed]);
    if (loading) {
        return (
            <div className="h-screen w-full flex items-center justify-center">
                <div className="text-muted-foreground text-sm">Caricamento...</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return (
        <div className="flex min-h-screen bg-background">
            <Sidebar
                collapsed={sidebarCollapsed}
                onToggleCollapsed={() => setSidebarCollapsed((value) => !value)}
            />
            <main className="flex-1 min-w-0">
                <Outlet />
            </main>
        </div>
    );
}
